import { getDiceServiceUrl } from "@/constants";
import { Context } from "@/context";
import type { AllFamilySets, DiceSet } from "@/types";
import { useContext, useEffect, useState } from "react";

export const useDiceSets = () => {
  const { env, nodeEnv } = useContext(Context);
  const [diceSets, setDiceSets] = useState<DiceSet[]>();

  useEffect(() => {
    if (!nodeEnv || !env) return;

    (async () => {
      setDiceSets(
        (
          (await (
            await fetch(
              `${getDiceServiceUrl(nodeEnv, env)}/dice/v1/getallfamilysets`,
            )
          ).json()) as AllFamilySets
        ).data.flatMap(({ sets: { definitionData } }) => definitionData),
      );
    })();
  }, [env, nodeEnv]);

  return diceSets;
};
